export { getRecommendation, resolveRecomIdentity } from '@/data/recom/client';
export type { GetRecommendationOptions, RecomCallOptions } from '@/data/recom/client';

export {
	RECOM_ERROR_CODE,
	RECOM_PROXY_BASE_PATH,
	RECOM_USER_DATA_KEY,
} from '@/data/recom/constants';
export type { RecomErrorCode } from '@/data/recom/constants';

export { createRecomApiError, isRecomApiError, toRecomApiError } from '@/data/recom/errors';
export type { RecomApiError } from '@/data/recom/errors';

export { isAllowedRecomRoute, recomPaths } from '@/data/recom/endpoints';

export { toDpIARecommendationResponse } from '@/data/recom/toDpIARecommendation';

export * from '@/data/recom/types';
